export default __webpack_public_path__ + "static/media/banner-programa-de-compliance-01.da81f985.png";